import { API_URLS } from '@helpers/api';
import brand from '@helpers/brand';
import debounce from 'lodash/debounce';
import * as React from 'react';
import PulseLoader from 'react-spinners/PulseLoader';
import S from './SearchTypeahead.styles';
const SearchTypeahead = ({ query, noResultsText }) => {
    const [results, setResults] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const hasResults = results && results.length > 0;
    const debouncedFetch = React.useMemo(() => {
        return debounce(async (searchQuery) => {
            setLoading(true);
            if (!searchQuery || searchQuery.length < 3) {
                return;
            }
            try {
                const response = await fetch(`${API_URLS.SEARCH_SUGGESTIONS}?query=${searchQuery}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                });
                const data = (await response.json());
                setResults(data.results ?? []);
                setLoading(false);
            }
            catch (error) {
                console.error('Error fetching search results:', error);
            }
        }, 250);
    }, []);
    React.useEffect(() => {
        debouncedFetch(query);
        return () => {
            debouncedFetch.cancel();
        };
    }, [query, debouncedFetch]);
    if (query === '' || query.length < 3) {
        return null;
    }
    return (React.createElement(S.Results, null,
        React.createElement(S.List, null, loading ? (React.createElement(S.Loader, null,
            React.createElement(PulseLoader, { size: 14, color: brand.tertiary.nearlyWhite.light }),
            React.createElement("span", { className: "sr-only" }, "Loading..."))) : hasResults ? (results.map((result) => (React.createElement(S.Item, { key: result.id },
            React.createElement(S.Link, { href: result.url, target: "_self" },
                React.createElement("span", { dangerouslySetInnerHTML: { __html: boldWordsMatchingQuery(result.name, query) } }),
                ' ',
                "\u2022 ",
                React.createElement("small", null, result.nodeType)))))) : (React.createElement(S.Item, null, noResultsText ?? 'There are no results matching this search')))));
    /**
     * Highlights words in the text that match the query.
     */
    function boldWordsMatchingQuery(text, query) {
        const regex = new RegExp(`(${query})`, 'gi');
        return text.replace(regex, '<em>$1</em>');
    }
};
export default SearchTypeahead;
